import React from 'react'
import Banner from '@components/Banner'
import Box from '@components/Box'
import { MainContent, NextTeaser, SidebarContent } from './subcomponents'
import { useTranslatedTerms } from '@hooks'

const NewsDetailContent = ({ next, news, parentPage }) => {
  const { getTranslatedTerm } = useTranslatedTerms()

  // media contacts only in foreign sitelets
  const mediaContacts = parentPage?.modules?.find(
    ({ __typename }) => __typename === 'ContentfulModuleProfessionalsBlock'
  )?.professionals

  const translatedMediaContacts =
    'MEDIA CONTACTS' || getTranslatedTerm('mediaContacts')

  return (
    <Box mb={40}>
      <Banner
        stacked
        breadcrumbs
        height="22"
        to={parentPage?.slug}
        crumbLabel={'News'}
        gradient="blue-gold"
      >
        <MainContent
          contentType={'ContentfulNews'}
          parentPath={parentPage?.slug}
          crumbLabel={'News'}
          {...news}
        />
        <NextTeaser {...news} next={next} contentType={'ContentfulNews'} />
        <SidebarContent
          {...news}
          mediaContacts={mediaContacts}
          translation={translatedMediaContacts}
          subscribeLink={parentPage?.subscribeLink}
        />
      </Banner>
    </Box>
  )
}

export default NewsDetailContent
